/**
 * Modelo de objeto de opções do Input de texto;
 * @class InputFieldConfig
 * @namespace InputTextConfig
 */
 export class InputTextConfig {
    /**
     * Objeto de configuração base para um input de texto
     * @param {String} id - Id do input
     * @param {String} name - Name para configurações e referencias
     * @param {String} label - Texto a ser exibido na label
     * @param {Boolean} required - Boolean indicando se campo é obrigatório
     * @param {String} value - Valor Padrão (só utilizado na inicialização)
     * @param {Function} callbackFn - Função a ser executada no callback de mudança de valor
     */
    constructor(id, name, label, required = false, value = '', callbackFn = null, validationFn = null, disabled, placeholder = "Digite...", errorMessage = "Campo obrigatório") {
      this.id = id;
      this.name = name;
      this.label = label;
      this.required = required;
      this.value = value;
      this.callbackFn = callbackFn;
      this.validationFn = validationFn;
      this.disabled = disabled;
      this.placeholder = placeholder;
      this.errorMessage = errorMessage;
    }
  }